import React, { useEffect, useState } from "react";
import Modal from "../../ReusableComponents/Modal";
import Button from "./Button";
import {RESCHEDULED_REASONS} from "../../appConstants";
import Calender from "react-calendar";

export default function ReschduleRequestPopup({
  open,
  onClose,
  date,
  onRequestUpdate,
}) {
  const [reschduleReason, setreschduleReason] = useState(undefined);
  const [otherReason, setOtherReason] = useState("");
  const [selectedDate, setselectedDate] = useState(undefined);
  const [error, setError] = useState();
  const [otherReasonError, setOtherReasonError] = useState("");


  const handleChange = (event) => {
    const value = event.target.value;
    setreschduleReason(value);
    if (value !== "Other") {
      setOtherReason("");
      setOtherReasonError("");
    }
  };

  const handleOtherReasonChange = (e) => {
    const value = e.target.value;
    setOtherReason(value);

    const valid = /^[A-Za-z\s]{20,}$/;
    if (!valid.test(value)) {
      setOtherReasonError("reason must be at least 20 characters and contain only letters and spaces.");
    }else   if(value.length>200){
      setOtherReasonError("reason must be less than 200 characters");
    } else {
      setOtherReasonError("");
    }
  };

  const handleDateChange = (newDate) => {
    const selected = new Date(newDate);
    setselectedDate(selected);
    if (selected?.toDateString() === new Date(date)?.toDateString()) {
      setError("Please select a different date to reschedule.");
    } else {
      setError("");
    }
  };

  useEffect(() => {
    if (date) {
      setselectedDate(() => new Date(date));
      if (selectedDate?.toDateString() === new Date(date)?.toDateString()) {
        setError("Please select a different date to reschedule.");
      }
    } else {
      setselectedDate(new Date());
    }
  }, [date]);

  const isSubmitDisabled =
    !selectedDate ||
    !reschduleReason ||
    error ||
    (reschduleReason === "Other" && (otherReason.trim() === "" || otherReasonError));

  return (
    <Modal
      header={"Reschedule Request"}
      open={open}
      onClose={() => {
        setreschduleReason(undefined);
        setselectedDate(new Date());
        setOtherReason("");
        setOtherReasonError("");
        onClose();
      }}
      contentStyle={{ width: "950px", height: "auto" }}
      divider={true}
      headerContainerStyle={{ padding: "15px 30px" }}
      headingStyle={{ fontSize: "16px", fontWeight: 600 }}
      iconSize={"18px"}
    >
      <div className="flex flex-col justify-between">
        <div className="flex w-full justify-between py-2 px-8">
          <div className="w-[55%]">
            <Calender
              className={"reschedule-calendar"}
              minDate={new Date()}
              onClickDay={handleDateChange}
              tileClassName={({ date }) =>
                date?.toDateString() === selectedDate?.toDateString()
                  ? "selected-date"
                  : "default-date"
              }
              value={selectedDate}
              defaultValue={selectedDate}
            />
            {error && (
              <p className="text-[#ef233c] font-manrope text-[14px] mt-2">{error}</p>
            )}
          </div>

          <div className="w-[45%] px-4">
            <h4 className="font-manrope font-[600] text-[16px]">
              Reason for reschedule
            </h4>
            <div className="flex flex-col gap-4 my-4">
              {[...RESCHEDULED_REASONS.map((r)=>({label:r,value:r})), { label: "Other", value: "Other" }].map((option) => (
                <div className="flex gap-2" key={option.value}>
                  <input
                    className="cursor-pointer focus:outline-none"
                    type="radio"
                    name="options"
                    value={option.value}
                    checked={reschduleReason === option.value}
                    onChange={handleChange}
                  />
                  <label>{option.label}</label>
                </div>
              ))}

              {reschduleReason === "Other" && (
                <div className="">
                  <textarea
                  style={{
                    resize: "none",
                  }}
                    value={otherReason}
                    rows={3}
                    onChange={handleOtherReasonChange}
                    className="w-full placeholder:text-[14px] border border-[#BFC8D9] text-[#1E1E1E] rounded px-3 py-2 focus:outline-none max-h-[80px] "
                    placeholder="Enter your reason"
                  />
                  {otherReasonError && (
                    <p className="text-[#ef233c] font-manrope text-[13px] font-[600] leading-4">
                      {otherReasonError}
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="flex ml-auto px-8 py-4 gap-6">
          <Button
            color={"#606571"}
            variant={"outlined"}
            title={"Cancel"}
            handleClick={onClose}
          />
          <Button
            color={"#0F5EFF"}
            isDisbaled={isSubmitDisabled}
            variant={"filled"}
            title={"Reschedule"}
            hoverColor={"#1251D2"}
            handleClick={() =>
              onRequestUpdate(
                new Date(selectedDate),
                reschduleReason === "Other" ? otherReason.trim() : reschduleReason
              )
            }
          />
        </div>
      </div>
    </Modal>
  );
}
